import { useMemo } from 'react';

import { useSetsQuery } from '@/features/sets/hooks/api';

import type { PrintingSetInfo, SetInfoByCode } from '../lib/printingFilter';

/** Set code (lowercase) → name/release/icon lookup built from the synced sets atom */
export default function useSetInfoByCode(): SetInfoByCode {
  const { data: sets } = useSetsQuery();
  return useMemo(() => {
    const map = new Map<string, PrintingSetInfo>();
    for (const set of sets ?? []) {
      map.set(set.code.toLowerCase(), { name: set.name, releasedAt: set.released_at, iconSvgUri: set.icon_svg_uri });
    }
    return map;
  }, [sets]);
}
